module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Prologue.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-13"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "sub"
  }, [_vm._v("Paris"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("—1816")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("‘H")]), _vm._v("e is dead?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cecilia Lockhart stood in the doorway of the shabby Paris room where her husband insisted she should be grateful to lodge. Sounds of babies crying, a man and woman quarrelling, and an old woman wailing could be heard from behind closed doors. The scent of cooking meat, urine and sweat filled her nostrils.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A captain of the 52nd Regiment of Foot stood stiffly in the hallway, unable—or unwilling—to look her in the eye.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Killed,’ he said. ‘By a Frenchman. In a duel.’ His tone was disapproving. Why not? Duelling was forbidden in the regiment. ‘He apparently had a great deal to drink.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Of course he had. What day did Duncan not have a great deal to drink?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘What happened?’ she asked. ‘Did he cheat at cards? Insult the French army?’ Why did she bother to ask? Cecilia did not care about the reason.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The captain stiffened. ‘The Frenchman apparently found Lieutenant Lockhart in bed with his wife.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Oh.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Why that detail should have stung, she did not know. It was merely one more humiliation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Another slap in the face.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She almost laughed at her little joke, but this stern, disapproving captain would never have understood.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘What happens next?’ she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘We’ll bury him,’ the captain replied. ‘You may return home. Do you have enough money to make the trip?’ He asked the question without sympathy, perhaps worried he would have to take up a collection among his fellow officers on her behalf.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I need nothing.’ Not from these men anyway. ‘Do what you must, and thank you for informing me.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He nodded and turned away. She closed the door and leaned her forehead against it. The baby cried. The old lady whined. The couple cursed each other. And the captain’s receding footsteps sounded on the wooden stairs.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But for Cecilia it was as if the sun had burst through a sky of dark clouds.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was free. Her husband was gone, never to return.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Never to slam his fist into her flesh ever again, nor throw her against the wall. No more bruises to hide. No more pain.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She had little money, no friends—Duncan had seen to that—and no one in England who would welcome her home. In a moment she might panic at being alone in this foreign country, among people who, a few short months ago, would have considered her the enemy. But for now she felt as light as air.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Free.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-10"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e064fd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prologue.vue
// module id = 78
// module chunks = 0